///////////////
// IMPORTS
//////////////
// schema
import * as ISchema from "@schema";
// libraries
import React from "react";
import ReactTooltip from "react-tooltip";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// avatar imports
import { avatarRowFragments } from "./AvatarRow.gql";
import { IAvatarRowProps, IAvatarRowContainer, IAvatarRowState } from "./Avatar.d";
import * as s from "./Avatar.styles";
import { AvatarPerson } from "./AvatarPerson";
// state
import { IReduxState } from "@reducers/root.reducer";
// util
import { roomString } from "@util/event.util";

//////////////////
// COMPONENT
//////////////////
class AvatarRowCmpt extends React.Component<IAvatarRowProps, IAvatarRowState> {
  private toolTipId = `AvatarRowTooltip`;

  constructor(props: IAvatarRowProps) {
    super(props);
    this.state = {
      maxRenderedAvatars: props.maxRenderedAvatars || 4,
    };
  }

  public render() {
    const {
      personList,
      org,
      style,
      size,
      parentName,
      toolTipContents,
      unClickable,
      hideUserBadge,
      filterRooms,
    } = this.props;

    if (!personList) {
      return <span />;
    }

    let list = personList.list;

    if (filterRooms) {
      list = list.filter((ai) => {
        // filter out rooms
        return ai.primaryEmail.indexOf(roomString) === -1;
      });
    }

    return (
      <div style={s.row}>
        {list
          .slice(0, this.state.maxRenderedAvatars) // grab first few to render, rest will be in a remainder
          .map((person: ISchema.IPerson, i) => {
            const toolTipContent = (!!toolTipContents && toolTipContents[i]) || undefined;
            return (
              <AvatarPerson
                org={org}
                person={person}
                orgPerson={null}
                style={{ ...style, marginRight: 10 }}
                size={size}
                key={person.primaryEmail}
                backupCalendarId={person.primaryEmail}
                parentName={parentName}
                toolTipContent={toolTipContent}
                unClickable={unClickable}
                hideUserBadge={hideUserBadge}
              />
            );
          })}
        {list.length - this.state.maxRenderedAvatars > 0 ? (
          <div
            style={{ ...s.remainder, ...style, width: size, height: size }}
            data-for={this.toolTipId}
            data-tip
          >
            +{list.length - this.state.maxRenderedAvatars}
          </div>
        ) : (
          ""
        )}
        <ReactTooltip multiline effect="solid" type="dark" id={this.toolTipId}>
          {list.slice(this.state.maxRenderedAvatars, 8).map((person, i) => {
            const personIndex = this.state.maxRenderedAvatars + i;
            const toolTipContent = (!!toolTipContents && toolTipContents[personIndex]) || undefined;
            const content = toolTipContent || person.primaryEmail;
            return <div key={person.primaryEmail}>{content}</div>;
          })}
          {list.length - 8 > 0 ? <div>+{list.length - 8} more</div> : ""}
        </ReactTooltip>
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IAvatarRowContainer) {
  return {};
}

export const AvatarRowRedux = connect(mapStateToProps, {})(AvatarRowCmpt);

//////////////////
// RELAY
//////////////////
export const AvatarRow = createFragmentContainer<IAvatarRowContainer>(
  AvatarRowRedux,
  avatarRowFragments,
);
